// Cookie-backed holder for the auth tokens issued at each step of the login flow.
// Each token is written under its own cookie name so the source of a token is
// visible from document.cookie:
//   - user_token    - the pre-selection token from POST /login/password
//   - client_token  - the real session token from POST /login/client-selection
//                     (also what every authenticated request's Authorization
//                     header is built from - see src/utils/api.js)
//   - refresh_token - the renewed access token from POST /auth/refresh
const COOKIE_NAMES = {
  user: 'user_token',
  client: 'client_token',
  refresh: 'refresh_token'
}

const isBrowser = () => typeof document !== 'undefined'

const readCookie = name => {
  if (!isBrowser()) {
    return null
  }
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : null
}

const writeCookie = (name, value) => {
  if (!isBrowser()) {
    return
  }
  if (!value) {
    document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`
    return
  }
  const secure = window.location?.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax${secure}`
}

export const tokenStore = {
  get: () => readCookie(COOKIE_NAMES.client),
  set: token => writeCookie(COOKIE_NAMES.client, token),

  getUserToken: () => readCookie(COOKIE_NAMES.user),
  setUserToken: token => writeCookie(COOKIE_NAMES.user, token),

  getRefreshToken: () => readCookie(COOKIE_NAMES.refresh),
  setRefreshToken: token => writeCookie(COOKIE_NAMES.refresh, token),

  clear: () => {
    writeCookie(COOKIE_NAMES.client, null)
    writeCookie(COOKIE_NAMES.user, null)
    writeCookie(COOKIE_NAMES.refresh, null)
  }
}
